module.exports = __webpack_public_path__ + "static/img/labourkuang.674d9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourkuang.png
// module id = dQSG
// module chunks = 1